export const rndProjects = [
  {
    id: 'RND-001',
    title: 'AI 기반 에너지 수요 예측 플랫폼 개발',
    category: 'AI Energy Platform',
    period: '2023.03 - 2025.02',
    status: '완료',
    desc: '머신러닝 기반 전력 수요 예측 모델을 개발하여 전력망 운영 효율성을 30% 향상시키는 플랫폼 구축.',
    funder: '자체 연구',
  },
  {
    id: 'RND-002',
    title: '스마트그리드 디지털 트윈 시스템',
    category: 'Digital Twin',
    period: '2024.01 - 2026.12',
    status: '진행중',
    desc: '실시간 전력망 데이터를 디지털로 복제하여 시뮬레이션 및 예측 분석을 수행하는 디지털 트윈 시스템 개발.',
    funder: '산업통상자원부',
  },
  {
    id: 'RND-003',
    title: '분산형 재생에너지 네트워크 통합 제어',
    category: 'Distributed Energy',
    period: '2024.06 - 2027.05',
    status: '진행중',
    desc: '태양광, 풍력 등 분산 전원을 하나의 네트워크로 통합 운영하는 스마트 제어 알고리즘 연구.',
    funder: '한국에너지기술평가원',
  },
  {
    id: 'RND-004',
    title: '에너지 효율화 AI 솔루션 상용화',
    category: 'AI Energy Platform',
    period: '2025.01 - 2026.12',
    status: '진행중',
    desc: '건물 및 공장의 에너지 사용 패턴을 분석하여 자동으로 최적화하는 AI 솔루션 상용화.',
    funder: '자체 연구',
  },
  {
    id: 'RND-005',
    title: '수소에너지 통합 관리 플랫폼',
    category: 'Smart Grid',
    period: '2025.06 - 2028.05',
    status: '계획',
    desc: '수소 생산, 저장, 운송, 활용 전 주기를 AI로 최적화하는 통합 에너지 관리 플랫폼 기획.',
    funder: '예정',
  },
];

export const rndStats = [
  { label: '진행 중인 프로젝트', value: '3' },
  { label: '완료된 프로젝트', value: '1' },
  { label: '계획 중인 프로젝트', value: '1' },
  { label: '연구 인력', value: '15+' },
];